import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DeleteIcon } from '../../../images/trash.svg';

function DeleteStorage({ deleteVisible, setDeleteVisible, deleteData, id, open, setVisible }) {
  const { t } = useTranslation();
  const handleDelete = (id) => {
    deleteData(id);
    setDeleteVisible(!deleteVisible);
    setVisible(!open)
  }
  return (
    <div className="bg-ghostred fixed inset-0 z-10 flex items-center justify-center">
      <div className="flex items-center flex-col justify-center text-white">
        <div>
          <DeleteIcon />
        </div>
        <div className="text-24 mb-3">
          {t('confirmDeleteStorageTitle')}Бобров переулок
        </div>
        <div className="w-3/4 text-center text-20 mb-10">
          {t('deleteStorageMessage1')} 250 {t('boxes')} {t('and')} 60{' '}
          {t('customersWillBeUnhooked')}.
        </div>
        <div className="text-24 mb-10">{t('youSure')}</div>
        <div className="flex">
          <Button
            onClick={() => {
              setDeleteVisible(!deleteVisible);
            }}
            type="ghost"
            className="pr-40 pl-40 pb-5 pt-5 flex items-center text-white mr-10 text-16 rounded-md"
          >
            {t('notDelete')}
          </Button>
          <Button
            onClick={() => {
              handleDelete(id);
            }}
            className="flex pr-40 pl-40 pb-5 pt-5 items-center bg-white text-16 m-1 rounded-md delete"
          >
            {t('yesDelete')}
          </Button>
        </div>
      </div>
    </div>
  );
}

DeleteStorage.propTypes = {};

export default DeleteStorage;
